import service from '@/services/SIRsic_sal_bol';

export default {
  namespaced: true,

  actions: {
    /**
     * Petición para obtener las salas relacionadas (sub-salas) con una sala en particular.
     */
    async read({ dispatch, rootGetters }, values) {
      return new Promise((resolve, reject) => {
        const { roomId, id } = values;

        const payload = {
          dsSIRsic_sal_bol: {
            eeDatos: [rootGetters['auth/state']],
            eeSIRsic_sal_bol: [
              {
                picbol_des: '*',
                picbol_id: id || 0,
                piisal_cod: roomId || 0,
              },
            ],
          },
        };

        let notification;

        service
          .read(payload)
          .then((response) => {
            const data = response.data.dsSIRsic_sal_bol;

            if (data.eeEstados[0].Returnid === 0) {
              resolve(data?.eesic_sal_bol);
            } else if (data.eeEstados[0].Returnid === 98) {
              resolve([]);
            } else {
              notification = {
                code: data.eeEstados[0].Returnid,
                message: data.eeEstados[0].Estado,
                timestamp: Date.now(),
                type: 'error',
              };

              throw notification;
            }
          })
          .catch((error) => {
            if (error.type === undefined) {
              notification = {
                code: undefined,
                message: error.message,
                timestamp: Date.now(),
                type: 'error',
              };
            }

            dispatch('notification/create', notification, {
              root: true,
            });

            reject(notification);
          });
      });
    },
  },
};
